module.exports = __webpack_public_path__ + "static/img/cuelist-list.af9c52c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cuelist-list.svg
// module id = 1099
// module chunks = 21